import React from 'react'
import "./financial.scss"
import BestOption from './sections/bestOption'
import MonitoringAccount from './sections/monitoringAccount'
import ComplianceList from "./sections/complianceList"
import Letsgo from "../connectors/letsgo"

function Financial() {
  return (
    <div className='container-financial'>
        <div className="section-best-option">
          <BestOption />
        </div>
        <div className="section-monitoring-account">
          <MonitoringAccount />
        </div>
        <div className="section-compliance-list">
        <ComplianceList />
        </div>
        <div className="section-letsgo">
          <Letsgo />
        </div>
    </div>
  )
}

export default Financial